import { CompanySearchParams } from 'src/types';
import { companyReportsAxiosInstance } from './axiosInstance.service';

export const searchCompany = (searchParams: CompanySearchParams) => {
  return companyReportsAxiosInstance.get('/company/search', {
    params: { ...searchParams },
  });
};
